import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" id=\"icon-document\">\r\n    <path d=\"M13.34,3.58A14.19,14.19,0,0,0,12,2,14.19,14.19,0,0,0,10.42.66,2.49,2.49,0,0,0,9,0H1.25A1.25,1.25,0,0,0,0,1.25v13.5A1.25,1.25,0,0,0,1.25,16h11.5A1.25,1.25,0,0,0,14,14.75V5A2.49,2.49,0,0,0,13.34,3.58Zm-2.07-.85A13.66,13.66,0,0,1,12.41,4H10V1.6a13.53,13.53,0,0,1,1.27,1.13Zm1.73,12a.25.25,0,0,1-.25.25H1.25A.25.25,0,0,1,1,14.75V1.25A.25.25,0,0,1,1.25,1H9V4.5a.5.5,0,0,0,.5.5H13Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/document.svg
// module id = LUPE
// module chunks = 0